import { useFormik, FormikProvider } from 'formik';
import { Grid, Flex } from 'common/containers';
import * as Yup from 'yup';
import 'utils/yupExtensions';
import { useIntl } from 'react-intl';
import useManageForms from 'hooks/useManageForms';
// inputs
import Input from 'components/forms/inputs/input';
import Submit from 'components/forms/inputs/submit';
import Date from 'components/forms/inputs/date';
import SelectFetch from 'common/tableFilters/fetchSelect';
import moment from 'moment';
const AddExpensesForm = () => {
	const { formatMessage } = useIntl();
	const { submit } = useManageForms();
	const formik = useFormik({
		initialValues: {
			name: '',
			quantity: null,
			createdAt: moment().toDate(),
			paymentMethodId: '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Este campo es obligatorio'),
			quantity: Yup.number()
				.required('Este campo es obligatorio')
				.min(1, 'La cantidad debe ser mayor o igual a 1'),
			createdAt: Yup.date().required('Este campo es obligatorio'),
		}),
		onSubmit: async (values, { setSubmitting }) => {
			setSubmitting(true);
			await submit(values, '/expenses', 'Gasto añadido correctamente', '/expenses');
		},
	});
	return (
		<FormikProvider value={formik}>
			<form onSubmit={formik.handleSubmit}>
				{/* basic fields */}
				<Grid $columns={2}>
					<Input
						nameData="name"
						placeholderData="Descripción del gasto"
						typeData="text"
						label="Gasto"
					/>
					<Input
						nameData="quantity"
						placeholderData="Cantidad"
						typeData="number"
						label="Cantidad"
					/>
					<Date
						nameData="createdAt"
						label="Fecha"
					/>
					<SelectFetch
						name="paymentMethodId"
						placeholder="Método de pago"
						url="/payment-methods"
						searchedValue="_id"
						searchedLabel="bank"
					/>
				</Grid>

				<Flex $margin="2rem 0 0 0">
					<Submit
						onClick={formik.handleSubmit}
						disabled={formik.isSubmitting}>
						{formatMessage({ id: 'commons.save' })}
					</Submit>
				</Flex>
			</form>
		</FormikProvider>
	);
};
export default AddExpensesForm;
